import apiCall from '../utils/api';
import { PAGEID } from '../utils/i18nRosseta';

export async function mediaPreSign(keys) {
  const url = '/control-panel/flight-path/v1/media/presign';
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: keys
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
}

export async function uploadToS3(url, data) {
  const withCredentials = false;
  const apiArgs = {
    API_CALL: {
      method: 'PUT',
      data
    },
    url,
    extraPayload: {
      responseRequired: true,
      hasBaseUrl: true
    }
  };
  const response = await apiCall(apiArgs, withCredentials);
  return response;
}

export const preSignAndUploadToS3 = async (file, imageKey) => {
  const uploadUrls = await mediaPreSign({ keys: [imageKey] });
  if (uploadUrls) {
    const url = uploadUrls.put[imageKey];
    const response = await uploadToS3(url, file);
    if (response?.status === 200) {
      return { data: imageKey, error: null };
    }
  }
  return {
    data: null,
    error: uploadUrls?.data?.message || 'Image upload failed'
  };
};

export async function getAllTreatments() {
  const url = '/control-panel/flight-path/v1/treatment/my/all';
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
}

export const alignerSetAndDayUpdate = async (data) => {
  const url = `/control-panel/flight-path/v1/treatment/update-set`;
  const apiArgs = {
    API_CALL: {
      method: 'PUT',
      data
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};
export const imageKeyUpload = async (data) => {
  const url = '/control-panel/flight-path/v1/treatment/image';
  const apiArgs = {
    API_CALL: {
      method: 'PUT',
      data
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const fetchImagesForSets = async (treatmentId) => {
  const url = `/control-panel/flight-path/v1/treatment/image/${treatmentId}`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const fetchAppointments = async (id) => {
  const url = `/control-panel/flight-path/v1/appointment/${id}`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const getTreatmentConsentForm = async () => {
  const url = '/control-panel/flight-path/v1/treatment/consent';
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const updateAppointment = async (id, status) => {
  const url = `/control-panel/flight-path/v1/appointment/${id}`;
  const apiArgs = {
    API_CALL: {
      method: 'PUT',
      data: {
        appointment_status: status
      }
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};
export const fetchRetainerJourneyDetails = async () => {
  const url = '/control-panel/flight-path/v1/treatment/retainer';
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const fetchDoctorComments = async (id) => {
  const url = `/control-panel/flight-path/v1/treatment/${id}/doctor-comments`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const fetchFeatureEnabledStatus = async () => {
  const url = `/control-panel/flight-path/v1/feature-status`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const validateToken = async (token) => {
  const url = '/ums/v1/auth/temp-auth-token/verify';
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: {
        token,
        source: PAGEID.FLIGHT_PATH
      }
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const linkWithIntercom = async (userId = '', employeeId = '') => {
  const url = `/ums/v1/users/${userId}/linkWithIntercom`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data: {
        employeeId
      }
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const getTreatmentSmilePlanDetails = async (treatmentId) => {
  const url = `/control-panel/flight-path/v1/treatment/${treatmentId}/tpv`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const updateTreatmentPlan = async (tpvSfId) => {
  const url = `/control-panel/flight-path/v1/tpv/${tpvSfId}`;
  const apiArgs = {
    API_CALL: {
      method: 'PUT',
      data: {
        acceptance_status: 'PATIENT_ACCEPTED'
      }
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const getDeliveryDetails = async (treatmentId) => {
  const url = `/control-panel/flight-path/v1/treatment/${treatmentId}/aligner-delivery`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const errorReport = async (data) => {
  const url = '/control-panel/flight-path/v1/report';
  const apiArgs = {
    API_CALL: {
      method: 'PUT',
      data
    },
    url
  };
  const res = await apiCall(apiArgs);
  return res;
};
